import MojitoCore from 'mojito/core';

import {resolveBackground} from '#core/utils/color-utils.js';
import {borderStyle} from '#core/utils/style-utils.js';

import {generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

const merge = MojitoCore.Presentation.uiStyle.merge;

export function toastConfig(PALETTE) {
    const {FONT} = PALETTE;

    return {
        ToastView: {
            clickableArea: {
                style: {
                    base: {
                        ...resolveBackground(PALETTE.TOAST_BG),
                        ...borderStyle(PALETTE.TOAST_BORDER_RADIUS, PALETTE.TOAST_BORDER_COLOR),
                        boxShadow: PALETTE.TOAST_SHADOW,
                    },
                },
            },
            title: {
                style: {
                    fontSize: FONT.SIZE_SMALL,
                    ...PALETTE.TOAST_TITLE_TEXT,
                },
            },
            message: {
                style: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    textAlign: 'center',
                    ...PALETTE.TOAST_MESSAGE_TEXT,
                },
            },
            closeButton: merge(generateCloseButton(PALETTE.TOAST_CLOSE_BUTTON), {
                buttonIcon: {
                    style: {
                        width: 8,
                        height: 8,
                        minWidth: 8,
                        minHeight: 8,
                    },
                },
            }),
        },
    };
}
